import { Card, Text, Group, Button, Anchor } from "@mantine/core";
import { NavLink } from "react-router-dom";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import { dataAutorizacoes } from "@/src/routes/empresa-page/EmpresaPage";
import JogadasDeInovacaoList from "../jogadas-de-inovacao-list";
// prettier-ignore
const JogadasDeInovacaoHeader = () => {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresa);
  const activeAutorizacao = useUserStore((store) => store.autorizacoes);
  const uid = getCurrentUser()?.uid;
  const { data: userColaborador } = useGetColaboradorById(activeEmpresaId?.id || "", uid || "");
  const autorizacao = dataAutorizacoes.find(item => item.label === userColaborador?.role);
  const formatAutorizacoes = activeAutorizacao?.filter(item => item.tipo === autorizacao?.value);

  return (
    <>
      <Card withBorder>
        <Card.Section inheritPadding py="md" withBorder>
          <Group justify="space-between" style={{ marginBottom: 20 }}>
            <Text size="xl" fw={500}>
              Jogadas de Inovação
            </Text>

            {formatAutorizacoes?.find(item => item.tipoAutorizacao === "21")?.criacao ?
              <Anchor component={NavLink} to={`/jogadas-de-inovacao/sugerida/0`} underline="never">
                <Button variant="outline" radius="lg" size="md">
                  <Text size="sm">Criar jogadas de inovação</Text>
                </Button>
              </Anchor> : <></>}
          </Group>
          <JogadasDeInovacaoList formatAutorizacoes={formatAutorizacoes} />
        </Card.Section>
      </Card>
    </>
  );
};

export default JogadasDeInovacaoHeader;
